import { render, staticRenderFns } from "./vendorForm.vue?vue&type=template&id=34d0f060&scoped=true"
import script from "./vendorForm.vue?vue&type=script&lang=js"
export * from "./vendorForm.vue?vue&type=script&lang=js"
import style0 from "./vendorForm.vue?vue&type=style&index=0&id=34d0f060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d0f060",
  null
  
)

export default component.exports